module.exports = __webpack_public_path__ + "static/media/381-removebg-preview.c2a32051.png";